import React from "react";
import { Icons } from "../../../../config/MuiIcons.config";
import "./LeaderboardCard.style.css";

const LeaderboardCard = ({ leaderboard }) => {
  // Format seconds to MM:SS format
  const formatTime = (seconds) => {
    if (!seconds && seconds !== 0) return "0:00";
    
    // Handle if it's already a string with 's' suffix
    const numSeconds = typeof seconds === 'string' 
      ? parseFloat(seconds.replace('s', '')) 
      : parseFloat(seconds);
    
    if (isNaN(numSeconds)) return "0:00";
    
    const mins = Math.floor(numSeconds / 60);
    const secs = Math.floor(numSeconds % 60);
    return `${mins}:${String(secs).padStart(2, '0')}`;
  };

  // Show top 10 entries
  const topEntries = leaderboard?.top10 || [];

  if (!topEntries || topEntries.length === 0) {
    return (
      <div className="leaderboard-card">
        <h2 className="leaderboard-title">Leaderboard</h2>
        <div className="leaderboard-empty">No leaderboard entries yet</div>
      </div>
    );
  }

  return (
    <div className="leaderboard-card">
      <h2 className="leaderboard-title">Leaderboard</h2>
      <div className="leaderboard-entries">
        {topEntries.map((entry, index) => {
          const rank = entry?.rank;
          let rankClass = '';
          if (rank === 1) {
            rankClass = 'leaderboard-entry-gold';
          } else if (rank === 2) {
            rankClass = 'leaderboard-entry-silver';
          } else if (rank === 3) {
            rankClass = 'leaderboard-entry-bronze';
          }
          
          return (
            <div 
              key={entry.id || index} 
              className={`leaderboard-entry ${rankClass}`}
            >
              <div className={`leaderboard-rank ${rankClass ? `leaderboard-rank-${rankClass.split('-').pop()}` : ''}`}>
                {rank}
              </div>
              <div className="leaderboard-user-info">
                <div className="leaderboard-name">
                  {entry.userName}
                </div>
                {/* <div className="leaderboard-email">
                  {entry.userEmail}
                </div> */}
              </div>
              <div className="leaderboard-time">
                <Icons.TimerIcon className="leaderboard-time-icon" />
                <span className="leaderboard-time-text">
                  {formatTime(entry.completionTime)}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LeaderboardCard;

